var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signature-settings" }, [
    _c("div", { staticClass: "settings-group" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localFieldLabel,
            expression: "localFieldLabel",
          },
        ],
        ref: "fieldLabelInput",
        staticClass: "settings-input",
        attrs: { type: "text", placeholder: "İmza" },
        domProps: { value: _vm.localFieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldLabel = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [_vm._v("Hizalama")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localAlign,
              expression: "localAlign",
            },
          ],
          staticClass: "settings-select",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.localAlign = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.updateField,
            ],
          },
        },
        [
          _c("option", { attrs: { value: "top" } }, [_vm._v("Üst")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "left" } }, [_vm._v("Sol")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "center" } }, [_vm._v("Merkez")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "right" } }, [_vm._v("Sağ")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [_vm._v("Alt Etiket")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localAltLabel,
            expression: "localAltLabel",
          },
        ],
        ref: "altLabelInput",
        staticClass: "settings-input",
        attrs: { type: "text", placeholder: "Lütfen imzanızı çiziniz" },
        domProps: { value: _vm.localAltLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localAltLabel = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("div", { staticClass: "settings-checkbox-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localIsRequired,
              expression: "localIsRequired",
            },
          ],
          staticClass: "settings-checkbox",
          attrs: { type: "checkbox", id: "signature-required" },
          domProps: {
            checked: Array.isArray(_vm.localIsRequired)
              ? _vm._i(_vm.localIsRequired, null) > -1
              : _vm.localIsRequired,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localIsRequired,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localIsRequired = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localIsRequired = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localIsRequired = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "settings-checkbox-label",
            attrs: { for: "signature-required" },
          },
          [_vm._v("\n                Zorunlu alan\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-checkbox-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localVisibility,
              expression: "localVisibility",
            },
          ],
          staticClass: "settings-checkbox",
          attrs: { type: "checkbox", id: "signature-visibility" },
          domProps: {
            checked: Array.isArray(_vm.localVisibility)
              ? _vm._i(_vm.localVisibility, null) > -1
              : _vm.localVisibility,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localVisibility,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localVisibility = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localVisibility = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localVisibility = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "settings-checkbox-label",
            attrs: { for: "signature-visibility" },
          },
          [_vm._v("\n                Alan görünür\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c(
        "label",
        { staticClass: "settings-label", attrs: { for: "slug-input" } },
        [_vm._v("URL Parametresi")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localSlug,
            expression: "localSlug",
          },
        ],
        ref: "slugInput",
        staticClass: "settings-input",
        attrs: { type: "text", id: "slug-input", placeholder: "signature" },
        domProps: { value: _vm.localSlug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localSlug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "settings-help" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "settings-section-title" }, [
        _vm._v("Canvas Boyutları"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-row" }, [
        _c("div", { staticClass: "settings-group" }, [
          _c("label", { staticClass: "settings-label" }, [
            _vm._v("Genişlik (px)"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localCanvasWidth,
                expression: "localCanvasWidth",
                modifiers: { number: true },
              },
            ],
            staticClass: "settings-input",
            attrs: {
              type: "number",
              min: "200",
              max: "800",
              placeholder: "400",
            },
            domProps: { value: _vm.localCanvasWidth },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localCanvasWidth = _vm._n($event.target.value)
                },
                _vm.updateField,
              ],
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "settings-group" }, [
          _c("label", { staticClass: "settings-label" }, [
            _vm._v("Yükseklik (px)"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localCanvasHeight,
                expression: "localCanvasHeight",
                modifiers: { number: true },
              },
            ],
            staticClass: "settings-input",
            attrs: {
              type: "number",
              min: "100",
              max: "400",
              placeholder: "200",
            },
            domProps: { value: _vm.localCanvasHeight },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localCanvasHeight = _vm._n($event.target.value)
                },
                _vm.updateField,
              ],
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "settings-section-title" }, [
        _vm._v("Çizim Ayarları"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("label", { staticClass: "settings-label" }, [_vm._v("Kalem Rengi")]),
        _vm._v(" "),
        _c("div", { staticClass: "color-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localStrokeColor,
                expression: "localStrokeColor",
              },
            ],
            staticClass: "settings-color-input",
            attrs: { type: "color" },
            domProps: { value: _vm.localStrokeColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localStrokeColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localStrokeColor,
                expression: "localStrokeColor",
              },
            ],
            staticClass: "settings-input color-text-input",
            attrs: { type: "text", placeholder: "#000000" },
            domProps: { value: _vm.localStrokeColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localStrokeColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("label", { staticClass: "settings-label" }, [
          _vm._v("Kalem Kalınlığı (px)"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "range-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localStrokeWidth,
                expression: "localStrokeWidth",
                modifiers: { number: true },
              },
            ],
            staticClass: "settings-range",
            attrs: { type: "range", min: "1", max: "10", step: "1" },
            domProps: { value: _vm.localStrokeWidth },
            on: {
              input: _vm.updateField,
              __r: function ($event) {
                _vm.localStrokeWidth = _vm._n($event.target.value)
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "range-value" }, [
            _vm._v(_vm._s(_vm.localStrokeWidth) + "px"),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "settings-section-title" }, [
        _vm._v("Görünüm Ayarları"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("label", { staticClass: "settings-label" }, [
          _vm._v("Arkaplan Rengi"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "color-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localBackgroundColor,
                expression: "localBackgroundColor",
              },
            ],
            staticClass: "settings-color-input",
            attrs: { type: "color" },
            domProps: { value: _vm.localBackgroundColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBackgroundColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localBackgroundColor,
                expression: "localBackgroundColor",
              },
            ],
            staticClass: "settings-input color-text-input",
            attrs: { type: "text", placeholder: "#ffffff" },
            domProps: { value: _vm.localBackgroundColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBackgroundColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("label", { staticClass: "settings-label" }, [
          _vm._v("Kenarlık Rengi"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "color-input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localBorderColor,
                expression: "localBorderColor",
              },
            ],
            staticClass: "settings-color-input",
            attrs: { type: "color" },
            domProps: { value: _vm.localBorderColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBorderColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localBorderColor,
                expression: "localBorderColor",
              },
            ],
            staticClass: "settings-input color-text-input",
            attrs: { type: "text", placeholder: "#e5e7eb" },
            domProps: { value: _vm.localBorderColor },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBorderColor = $event.target.value
                },
                _vm.updateField,
              ],
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-row" }, [
        _c("div", { staticClass: "settings-group" }, [
          _c("label", { staticClass: "settings-label" }, [
            _vm._v("Kenarlık Kalınlığı (px)"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localBorderWidth,
                expression: "localBorderWidth",
                modifiers: { number: true },
              },
            ],
            staticClass: "settings-input",
            attrs: { type: "number", min: "0", max: "10", placeholder: "1" },
            domProps: { value: _vm.localBorderWidth },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBorderWidth = _vm._n($event.target.value)
                },
                _vm.updateField,
              ],
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "settings-group" }, [
          _c("label", { staticClass: "settings-label" }, [
            _vm._v("Köşe Yuvarlaklığı (px)"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localBorderRadius,
                expression: "localBorderRadius",
                modifiers: { number: true },
              },
            ],
            staticClass: "settings-input",
            attrs: { type: "number", min: "0", max: "50", placeholder: "8" },
            domProps: { value: _vm.localBorderRadius },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.localBorderRadius = _vm._n($event.target.value)
                },
                _vm.updateField,
              ],
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "settings-section-title" }, [
        _vm._v("Buton Ayarları"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("div", { staticClass: "settings-checkbox-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localShowClearButton,
                expression: "localShowClearButton",
              },
            ],
            staticClass: "settings-checkbox",
            attrs: { type: "checkbox", id: "signature-show-clear" },
            domProps: {
              checked: Array.isArray(_vm.localShowClearButton)
                ? _vm._i(_vm.localShowClearButton, null) > -1
                : _vm.localShowClearButton,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.localShowClearButton,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.localShowClearButton = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.localShowClearButton = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.localShowClearButton = $$c
                  }
                },
                _vm.updateField,
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "settings-checkbox-label",
              attrs: { for: "signature-show-clear" },
            },
            [
              _vm._v(
                "\n                    Temizle butonu göster\n                "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.localShowClearButton
        ? _c("div", { staticClass: "settings-group" }, [
            _c("label", { staticClass: "settings-label" }, [
              _vm._v("Temizle Buton Metni"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localClearButtonText,
                  expression: "localClearButtonText",
                },
              ],
              ref: "clearButtonTextInput",
              staticClass: "settings-input",
              attrs: { type: "text", placeholder: "Temizle" },
              domProps: { value: _vm.localClearButtonText },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.localClearButtonText = $event.target.value
                  },
                  _vm.updateField,
                ],
              },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "settings-section-title" }, [
        _vm._v("Placeholder Ayarları"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-group" }, [
        _c("label", { staticClass: "settings-label" }, [
          _vm._v("Placeholder Metni"),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localPlaceholder,
              expression: "localPlaceholder",
            },
          ],
          ref: "placeholderInput",
          staticClass: "settings-input",
          attrs: { type: "text", placeholder: "Burada imza çizin" },
          domProps: { value: _vm.localPlaceholder },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localPlaceholder = $event.target.value
              },
              _vm.updateField,
            ],
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "settings-label" }, [
      _vm._v("\n            Alan Etiketi\n            "),
      _c("span", { staticClass: "settings-label-required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }